import type { GetStaticProps } from 'next';
import { getNavigation } from '../lib/navigation';
import { getSearchIndex } from '../lib/search';

export default function HomePage() {
  return (
    <article>
      <h1>Welcome to the Wellhub Developer Hub</h1>
      <p>
        This site helps you integrate your systems with Wellhub, whether you use REST APIs, SFTP file exchanges, or
        other automation options. Here you will find concepts, guides, and references to keep your company information
        in sync with Wellhub.
      </p>
      <p>
        Head to the <a href="/docs/integrations/api">API</a> or <a href="/docs/integrations/sftp">SFTP</a> documentation
        page to get started integrating.
      </p>
      <p>
        For more information about domain concepts, check the <a href="/docs/flows/eligibility">Eligibility</a> and{' '}
        <a href="/docs/flows/payroll">Payroll</a> sections.
      </p>
    </article>
  );
}

export const getStaticProps: GetStaticProps = async () => {
  const navigation = getNavigation();
  const searchIndex = getSearchIndex();

  return {
    props: {
      navigation,
      searchIndex,
    },
  };
};
